export enum SortingEnum {
  NotSorted = "NotSorted",
  Asc = "Asc",
  Desc = "Desc",
}

export enum SortEnumAPI {
  NoSort = 0,
  DefaultCustomSort = 1,
  SortById = 2,
  SortByIdDesc = 3,
  SortByTitle = 4,
  SortByTitleDesc = 5,
  SortByCreationDate = 6,
  SortByCreationDateDesc = 7,
  SortByUpdateDate = 8,
  SortByUpdateDateDesc = 9,
}
